function stickyFranchiseHeader(franchise_header, header_height, countdown_banner_height) {
    const trigger_height = countdown_banner_height ? countdown_banner_height : header_height;
    let submenu
        , responsive_height_adjustment = 0
        , countdown_banner_height_in_view = 0;

    if (countdown_banner_height > 0 && (countdown_banner_height - window.scrollY) > 0) {
        countdown_banner_height_in_view = countdown_banner_height - window.scrollY;
    }

    if (countdown_banner_height_in_view > 0 && window.innerWidth < 1025) {
        responsive_height_adjustment = 10;
    }

    countdown_banner_height_in_view += responsive_height_adjustment;

    if (franchise_header.length > 0) {
        if (countdown_banner_height > 0) {
            franchise_header.css({ top: `${countdown_banner_height_in_view}px` });

            // hack to adjust y pos of fixed position submenus
            $('.mainMenu > li').each(function() {
                submenu = $(this).find('.sub').not('.small');

                if (submenu.length > 0) {
                    submenu.css({ top: `${countdown_banner_height_in_view + 58}px` });
                }
            });
        }

        if (window.scrollY > trigger_height) {
            franchise_header.addClass("sticky");
        } else {
            franchise_header.removeClass("sticky");
        }
    }
}

$(document).ready(function () {
    const franchise_header = $('.newFranchiseHeader');
    let header_height, countdown_banner, countdown_banner_height;

    if (franchise_header.length > 0) {
        header_height = franchise_header.prop('clientHeight');
        countdown_banner = $('.js_countdownBannerWrap');
        countdown_banner_height = countdown_banner.length ? countdown_banner.prop('clientHeight') : 0;

        stickyFranchiseHeader(franchise_header, header_height, countdown_banner_height);

        $(window).scroll(function() {
            stickyFranchiseHeader(franchise_header, header_height, countdown_banner_height);
        });

        $(window).resize(function() {
            header_height = franchise_header.prop('clientHeight');
            countdown_banner_height = countdown_banner.length ? countdown_banner.prop('clientHeight') : 0;

            stickyFranchiseHeader(franchise_header, header_height, countdown_banner_height);
        });
    }
});


